var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShippedIcon = function SvgShippedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A",
    clipPath: "url(#ShippedIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625 11.167a.542.542 0 1 0 0 1.083h1.083a.542.542 0 1 0 0-1.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 3.042a.542.542 0 1 1 1.083 0v.541h4.334v-.541a.542.542 0 1 1 1.083 0v.541h1.083c1.197 0 2.167.97 2.167 2.167v7.583c0 1.197-.97 2.167-2.167 2.167H3.667A2.167 2.167 0 0 1 1.5 13.333V5.75c0-1.197.97-2.167 2.167-2.167H4.75zm5.417 1.625a.542.542 0 1 0 1.083 0h1.083c.599 0 1.084.485 1.084 1.083v1.625H2.583V5.75c0-.598.485-1.083 1.084-1.083H4.75a.542.542 0 0 0 1.083 0zm-7.584 8.666V8.458h10.834v4.875c0 .599-.485 1.084-1.084 1.084H3.667a1.083 1.083 0 0 1-1.084-1.084",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ShippedIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.5 2.5h13v13h-13z"
  })))));
};
export default SvgShippedIcon;